/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "cash": {
        "nested": {
          "gambit": {
            "nested": {
              "api": {
                "nested": {
                  "v1": {
                    "nested": {
                      "checkdeposit": {
                        "nested": {
                          "FundingStrategy": {
                            "values": {
                              "FUNDING_STRATEGY_UNSPECIFIED": 0,
                              "FUNDING_STRATEGY_DEFAULT": 1,
                              "FUNDING_STRATEGY_HOLD_DAYS_5": 2,
                              "FUNDING_STRATEGY_HOLD_DAYS_7": 3,
                              "FUNDING_STRATEGY_HOLD_DEFAULT": 4,
                              "FUNDING_STRATEGY_INSTANT": 5,
                              "FUNDING_STRATEGY_PARTIAL_DEFAULT": 6,
                              "FUNDING_STRATEGY_PARTIAL_HOLD_DAYS_5": 7
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.cash?.nested?.gambit?.nested?.api?.nested?.v1?.nested?.checkdeposit?.nested?.FundingStrategy) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE FundingStrategy @ squareup/cash/gambit/api/v1/checkdeposit/funding_strategy.proto at 7:1
 */
export const FundingStrategy = $root.lookupEnum('squareup.cash.gambit.api.v1.checkdeposit.FundingStrategy').values;